import React, { useState,useEffect } from 'react';

import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import { useNavigate } from 'react-router-dom';
import { productService } from '../../service/productservice';


import oloyePremiumPalmOil1L from "../../public/category-img/oil/oloye-plamoil_prev_ui.png";
import sarasGlobeOrganicPalmOil64oz from "../../public/category-img/oil/Sara'sglobeorganicPalmOil_prev_ui.png";
//import sarasGlobeOrganicPalmOil32oz from "../../public/category-img/oil/saras-globe-organic-palm-oil-32oz.png";
import goldenTerraVegetableOil2_75L from "../../public/category-img/oil/GoldenterraVegetableOil2.75L_prev_ui.png";
import goldenTerraVegetableOil10L from "../../public/category-img/oil/GoldenterraVegetableOil10L_prev_ui.png";
import goldenTerraVegetableOil25L from "../../public/category-img/oil/GoldenterraVegetableOil25L_prev_ui.png";
import mamadorVegetableOil500ml from "../../public/category-img/oil/MamadorVegetableOil500ml_prev_ui.png";
import mamadorVegetableOil900ml from "../../public/category-img/oil/MamadorVegetableOil900ml_prev_ui.png";
import mamadorVegetableOil1_5L from "../../public/category-img/oil/MAMADOR-VEGETABLE-OIL-1.5L_prev_ui.png";
import mamadorVegetableOil2_5L from "../../public/category-img/oil/MamadorVegetableOil2.5L_prev_ui.png";
import mamadorVegetableOil3_5L from "../../public/category-img/oil/MamadorVegetableOil3.5L_prev_ui.png";
import kingsVegetableOilBottle1L from "../../public/category-img/oil/Kings-vegetable-oil-1-litre_prev_ui.png";
import kingsVegetableOilBottle2L from "../../public/category-img/oil/Kings-Oil-2-Litres_prev_ui.png";
import kingsVegetableOilKeg5L from "../../public/category-img/oil/Kings-Oil-2-Litres_prev_ui.png";
import kingsVegetableOilKeg10L from "../../public/category-img/oil/KingsVegetableOil(keg)10L_prev_ui.png";
import kingsVegetableOilSachet1L from "../../public/category-img/oil/1L-Sachet-kings_prev_ui.png";
import powerOilVegetableOil750ml from "../../public/category-img/oil/PowerOilVegetableOil750mL_prev_ui.png";
import powerOilVegetableOil2_6L from "../../public/category-img/oil/PowerOilVegetableOil2.6L_prev_ui.png";
import powerOilVegetableOil5L from "../../public/category-img/oil/PowerOilVegetableOil5L_prev_ui.png";
import obijiPalmOil1L from "../../public/category-img/oil/ObijiPalmOil1L_prev_ui.png";
import criscoPureVegetableOil48FLOZ from "../../public/category-img/oil/Criscopurevegetableoil48FLOZ_prev_ui.png";
import obijiPalmOil3L from "../../public/category-img/oil/ObijiPalmOil3L_prev_ui.png";

export const oilproducts = [
  { id: 'OL001', name: 'Oloye Premium Palm Oil 1L', brand: 'Oloye', distributor: "Mimi's worldwide", price: '$7.95', img: oloyePremiumPalmOil1L, description: 'Oloye Premium Palm Oil is a natural, unrefined red palm oil widely used in African cuisine. Made from carefully selected palm fruits, it is rich in flavor, vibrant in color, and packed with essential nutrients like vitamins A and E. Its smooth texture and distinct aroma make it a versatile cooking ingredient, perfect for enhancing traditional dishes such as jollof rice, beans, fried plantains, or vegetable stir-fries.With no additives or preservatives, Oloye Premium Palm Oil offers an authentic and wholesome taste of Africa.' },
  { id: 'OL002', name: 'Oloye Premium Palm Oil 3L', brand: 'Oloye', distributor: "Mimi's worldwide", price: '$23.95', img: oloyePremiumPalmOil1L, description: 'Oloye Premium Palm Oil is a natural, unrefined red palm oil widely used in African cuisine. Made from carefully selected palm fruits, it is rich in flavor, vibrant in color, and packed with essential nutrients like vitamins A and E. Its smooth texture and distinct aroma make it a versatile cooking ingredient, perfect for enhancing traditional dishes such as jollof rice, beans, fried plantains, or vegetable stir-fries.With no additives or preservatives, Oloye Premium Palm Oil offers an authentic and wholesome taste of Africa.' },
  { id: 'OL003', name: "Sara's globe organic Palm Oil 64oz", brand: "Sara's globe", distributor: "Onola African import", price: '$16.95', img: sarasGlobeOrganicPalmOil64oz, description: "Sara's Globe Organic Palm Oil is a 100% organic, unrefined red palm oil made from naturally grown palm fruits. Rich in vitamins A and E, it supports eye health, boosts immunity, and promotes healthy skin. Its bold flavor and vibrant color enhance soups, stews, and rice dishes, delivering authentic African taste without additives or preservatives. Perfect for a nutritious and flavorful meal!" },
  { id: 'OL004', name: "Sara's globe organic Palm Oil 32oz", brand: "Sara's globe", distributor: '', price: '$9.00', img: sarasGlobeOrganicPalmOil64oz, description: "Sara's Globe Organic Palm Oil is a 100% organic, unrefined red palm oil made from naturally grown palm fruits. Rich in vitamins A and E, it supports eye health, boosts immunity, and promotes healthy skin. Its bold flavor and vibrant color enhance soups, stews, and rice dishes, delivering authentic African taste without additives or preservatives. Perfect for a nutritious and flavorful meal!" },
  { id: 'OL005', name: 'Golden terra Vegetable Oil 2.75L', brand: 'Golden terra', distributor: '', price: '$5.97', img: goldenTerraVegetableOil2_75L, description: "Golden Terra Vegetable Oil is a premium, refined soybean oil that's perfect for all your cooking needs. Cholesterol-free and rich in omega-3 fatty acids and vitamin E, it supports heart health and glowing skin. With its light texture and neutral flavor, it's ideal for frying, sautéing, and baking, enhancing every dish without overpowering its natural taste. A healthier choice for flavorful meals!" },
  { id: 'OL006', name: 'Golden terra Vegetable Oil 10L', brand: 'Golden terra', distributor: '', price: '$17.91', img: goldenTerraVegetableOil10L, description: "Golden Terra Vegetable Oil is a premium, refined soybean oil that's perfect for all your cooking needs. Cholesterol-free and rich in omega-3 fatty acids and vitamin E, it supports heart health and glowing skin. With its light texture and neutral flavor, it's ideal for frying, sautéing, and baking, enhancing every dish without overpowering its natural taste. A healthier choice for flavorful meals!" },
  { id: 'OL007', name: 'Golden terra Vegetable Oil 25L', brand: 'Golden terra', distributor: '', price: '$41.00', img: goldenTerraVegetableOil25L, description: "Golden Terra Vegetable Oil is a premium, refined soybean oil that's perfect for all your cooking needs. Cholesterol-free and rich in omega-3 fatty acids and vitamin E, it supports heart health and glowing skin. With its light texture and neutral flavor, it's ideal for frying, sautéing, and baking, enhancing every dish without overpowering its natural taste. A healthier choice for flavorful meals!" },
  { id: 'OL008', name: 'Mamador Vegetable Oil 500ml', brand: 'Mamador', distributor: '', price: '$2.05', img: mamadorVegetableOil500ml, description: 'Mamador Vegetable Oil is a refined, high-quality soybean oil that offers a light, neutral flavor perfect for various cooking methods. Rich in essential fatty acids and vitamin E, it supports heart health and nourishes the skin. Ideal for frying, sautéing, and baking, Mamador Vegetable Oil ensures delicious, healthier meals with every use.' },
  { id: 'OL009', name: 'Mamador Vegetable Oil 900ml', brand: 'Mamador', distributor: '', price: '$2.90', img: mamadorVegetableOil900ml, description: 'Mamador Vegetable Oil is a refined, high-quality soybean oil that offers a light, neutral flavor perfect for various cooking methods. Rich in essential fatty acids and vitamin E, it supports heart health and nourishes the skin. Ideal for frying, sautéing, and baking, Mamador Vegetable Oil ensures delicious, healthier meals with every use.' },
  { id: 'OL010', name: 'Mamador Vegetable Oil 1.5L', brand: 'Mamador', distributor: '', price: '$4.00', img: mamadorVegetableOil1_5L, description: 'Mamador Vegetable Oil is a refined, high-quality soybean oil that offers a light, neutral flavor perfect for various cooking methods. Rich in essential fatty acids and vitamin E, it supports heart health and nourishes the skin. Ideal for frying, sautéing, and baking, Mamador Vegetable Oil ensures delicious, healthier meals with every use.' },
  { id: 'OL011', name: 'Mamador Vegetable Oil 2.5L', brand: 'Mamador', distributor: '', price: '$6.00', img: mamadorVegetableOil2_5L, description: 'Mamador Vegetable Oil is a refined, high-quality soybean oil that offers a light, neutral flavor perfect for various cooking methods. Rich in essential fatty acids and vitamin E, it supports heart health and nourishes the skin. Ideal for frying, sautéing, and baking, Mamador Vegetable Oil ensures delicious, healthier meals with every use.' },
  { id: 'OL012', name: 'Mamador Vegetable Oil 3.5L', brand: 'Mamador', distributor: '', price: '$8.00', img: mamadorVegetableOil3_5L, description: 'Mamador Vegetable Oil is a refined, high-quality soybean oil that offers a light, neutral flavor perfect for various cooking methods. Rich in essential fatty acids and vitamin E, it supports heart health and nourishes the skin. Ideal for frying, sautéing, and baking, Mamador Vegetable Oil ensures delicious, healthier meals with every use.' },
  { id: 'OL013', name: 'Kings Vegetable Oil(bottle) 1L', brand: 'Kings', distributor: '', price: '$3.00', img: kingsVegetableOilBottle1L, description: 'Kings Vegetable Oil is a refined, cholesterol-free oil made from high-quality soybeans, designed to enhance the flavor of your meals. Rich in omega-3 fatty acids and vitamin E, it promotes heart health and nourishes the skin. Its light, neutral flavor makes it ideal for frying, baking, and sautéing, providing a versatile, healthier cooking option for everyday dishes.' },
  { id: 'OL014', name: 'Kings Vegetable Oil(bottle) 2L', brand: 'Kings', distributor: '', price: '$5.00', img: kingsVegetableOilBottle2L, description: 'Kings Vegetable Oil is a refined, cholesterol-free oil made from high-quality soybeans, designed to enhance the flavor of your meals. Rich in omega-3 fatty acids and vitamin E, it promotes heart health and nourishes the skin. Its light, neutral flavor makes it ideal for frying, baking, and sautéing, providing a versatile, healthier cooking option for everyday dishes.' },
  { id: 'OL015', name: 'Kings Vegetable Oil(keg) 5L', brand: 'Kings', distributor: '', price: '$10.00', img: kingsVegetableOilKeg5L, description: 'Kings Vegetable Oil is a refined, cholesterol-free oil made from high-quality soybeans, designed to enhance the flavor of your meals. Rich in omega-3 fatty acids and vitamin E, it promotes heart health and nourishes the skin. Its light, neutral flavor makes it ideal for frying, baking, and sautéing, providing a versatile, healthier cooking option for everyday dishes.' },
  { id: 'OL016', name: 'Kings Vegetable Oil(keg) 10L', brand: 'Kings', distributor: '', price: '$19.43', img: kingsVegetableOilKeg10L, description: 'Kings Vegetable Oil is a refined, cholesterol-free oil made from high-quality soybeans, designed to enhance the flavor of your meals. Rich in omega-3 fatty acids and vitamin E, it promotes heart health and nourishes the skin. Its light, neutral flavor makes it ideal for frying, baking, and sautéing, providing a versatile, healthier cooking option for everyday dishes.' },
  { id: 'OL017', name: 'Kings Vegetable Oil(sachet) 1L', brand: 'Kings', distributor: '', price: '$2.75', img: kingsVegetableOilSachet1L, description: 'Kings Vegetable Oil is a refined, cholesterol-free oil made from high-quality soybeans, designed to enhance the flavor of your meals. Rich in omega-3 fatty acids and vitamin E, it promotes heart health and nourishes the skin. Its light, neutral flavor makes it ideal for frying, baking, and sautéing, providing a versatile, healthier cooking option for everyday dishes.' },
  { id: 'OL018', name: 'Power Oil Vegetable Oil 750mL', brand: 'Power oil', distributor: '', price: '$2.50', img: powerOilVegetableOil750ml, description: 'Power Oil is a refined vegetable oil made from high-quality soybeans, offering a light, neutral flavor for a variety of cooking needs. Rich in essential fatty acids and vitamin E, it supports heart health and promotes healthy skin. Perfect for frying, sautéing, and baking, Power Oil provides a healthy, versatile option to enhance the taste and nutrition of your meals.' },
  { id: 'OL019', name: 'Power Oil Vegetable Oil 2.6L', brand: 'Power oil', distributor: '', price: '$7.85', img: powerOilVegetableOil2_6L, description: 'Power Oil is a refined vegetable oil made from high-quality soybeans, offering a light, neutral flavor for a variety of cooking needs. Rich in essential fatty acids and vitamin E, it supports heart health and promotes healthy skin. Perfect for frying, sautéing, and baking, Power Oil provides a healthy, versatile option to enhance the taste and nutrition of your meals.' },
  { id: 'OL020', name: 'Power Oil Vegetable Oil 5L', brand: 'Power oil', distributor: '', price: '$12.07', img: powerOilVegetableOil5L, description: 'Power Oil is a refined vegetable oil made from high-quality soybeans, offering a light, neutral flavor for a variety of cooking needs. Rich in essential fatty acids and vitamin E, it supports heart health and promotes healthy skin. Perfect for frying, sautéing, and baking, Power Oil provides a healthy, versatile option to enhance the taste and nutrition of your meals.' },
  { id: 'OL021', name: 'Obiji Palm Oil 1L', brand: 'Obiji food', distributor: 'Obiji food', price: '$9.95', img: obijiPalmOil1L, description: 'Obiji Palm Oil is a premium, unrefined red palm oil made from carefully selected palm fruits. Rich in vitamins A and E, it supports eye health, boosts immunity, and promotes healthy skin. Its rich flavor and vibrant color make it perfect for cooking traditional African dishes like jollof rice,egusi soup and other ethnic Africa soups, adding both nutritional benefits and authentic taste to your meals.' },
  { id: 'OL022', name: 'Crisco pure vegetable oil 48FL OZ', brand: 'Crisco', distributor: 'Walmart', price: '$4.85', img: criscoPureVegetableOil48FLOZ, description: 'Crisco Pure Vegetable Oil is a refined, cholesterol-free oil made from a blend of high-quality soybeans. With its light, neutral flavor, it is perfect for frying, baking, and sautéing. Rich in omega-3 fatty acids and vitamin E, it supports heart health and nourishes the skin. Crisco Pure Vegetable Oil provides a versatile and healthier cooking option for a wide range of recipes.' },
  { id: 'OL023', name: 'Obiji Palm Oil 3L', brand: 'Obiji food', distributor: 'Obiji food', price: '$23.95', img: obijiPalmOil3L, description: 'Obiji Palm Oil is a premium, unrefined red palm oil made from carefully selected palm fruits. Rich in vitamins A and E, it supports eye health, boosts immunity, and promotes healthy skin. Its rich flavor and vibrant color make it perfect for cooking traditional African dishes like jollof rice,egusi soup and other ethnic Africa soups, adding both nutritional benefits and authentic taste to your meals.' }
];

const ProductCard = ({ product, updateCartCount, forceUpdateKey }) => {
  const [inCart, setInCart] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const foundItem = storedCartItems.find((item) => item.id === product.id);
    if (foundItem) {
      setInCart(true);
      setQuantity(foundItem.quantity);
    } else {
      setInCart(false);
      setQuantity(0);
    }
  }, [product.id, forceUpdateKey]);

  const handleAddToCart = () => {
    if (!inCart) {
      setInCart(true);
      setQuantity(1);
      saveToLocalStorage(product, 1);
      updateCartCount();
    }
  };

  const handleProductClick = () => {
    navigate(`/product/${product.name}`);
  };

  const saveToLocalStorage = (product, quantity) => {
    const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const updatedCart = [...cartItems, { ...product, quantity }];
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-3 w-full flex flex-col justify-between">
      <div onClick={handleProductClick} className="relative cursor-pointer flex justify-center items-center">
        <img
          src={product.img}
          alt={product.name}
          className={`h-60 w-full object-cover rounded-lg ${product.quantity === 0 ? 'opacity-50' : ''}`}
        />
        {product.quantity === 0 && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-lg">
            <span className="text-white text-lg font-semibold">Out of Stock</span>
          </div>
        )}
      </div>
      <div className="mt-4">
        <h3 className="text-lg font-semibold">{product.name}</h3>
        <p className="text-[#007D44]">{product.brand}</p>
        <p className="text-[#007D44] font-bold mt-2">${product.price}</p>
      </div>
      {inCart ? (
        <div className="mt-4 flex items-center justify-between border bg-slate-100 shadow-md rounded-full">
          <button
            onClick={() => {
              if (quantity > 1) {
                setQuantity((prevQuantity) => prevQuantity - 1);
                updateCartCount();
              }
            }}
            className="bg-[#38c13a] text-white py-2 px-4 rounded-lg hover:bg-[#2e9830]"
          >
            -
          </button>
          <span className="text-lg font-semibold">{quantity}</span>
          <button
            onClick={() => {
              setQuantity((prevQuantity) => prevQuantity + 1);
              updateCartCount();
            }}
            className="bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44]"
          >
            +
          </button>
        </div>
      ) : (
        <button
          onClick={handleAddToCart}
          className={`mt-4 bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44] ${
            product.quantity === 0 ? 'cursor-not-allowed opacity-50' : ''
          }`}
          disabled={product.quantity === 0}
        >
          Add to cart
        </button>
      )}
    </div>
  );
};


const OilProduct = () => {
  const [cartCount, setCartCount] = useState(0);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);


  const [uploadStatus, setUploadStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [cloudinaryUrls, setCloudinaryUrls] = useState({});
  const [products, setProducts] = useState([]);

    const [hasIncompatibleItems, setHasIncompatibleItems] = useState(false); // New state
      

 // Auto-upload products when component mounts
 useEffect(() => {
  const uploadProducts = async () => {
    try {
      setIsUploading(true);

      // Prepare products for upload
      const productsToUpload = oilproducts.map(product => ({
        ...product,
        id: product.id,
        name: product.name,
        brand: product.brand,
        description: product.description,
        category: 'oilproducts',
        quantity: 0,
        price: parseFloat(product.price.replace('$', ''))
      }));

      try {
        const result = await productService.bulkCreateProducts(productsToUpload);
        
        setUploadStatus({
          success: true,
          message: `${result.created} beauty products uploaded successfully`
        });
      } catch (error) {
        setUploadStatus({
          success: false,
          message: error.response?.data?.message || 'Product upload failed'
        });
      }
    } catch (error) {
      console.error('Error uploading products:', error);
      setUploadStatus({
        success: false,
        message: 'Failed to upload products'
      });
    } finally {
      setIsUploading(false);
    }
  };


  // Fetch products by category
  const fetchProducts = async () => {
    try {
      const result = await productService.getProductsByCategory('oilproducts');
      
      // If no products exist, trigger upload
      if (result.count === 0) {
        await uploadProducts();
      } else {
        setProducts(result.products);
        console.log(result.products)
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  fetchProducts();
}, []);

 

 useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items on initial load
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);

  }, []);

  const updateCartCount = () => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items whenever cart updates
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);
  };

  const forceUpdateProducts = () => {
    setForceUpdateKey(prevKey => prevKey + 1); // This will force a re-render in ProductCard
  };

  return (
    <>
      <Navbar cartCount={cartCount} updateCartCount={updateCartCount} forceUpdateProducts={forceUpdateProducts} /> {/* Pass cart count to Navbar */}

      {/* Upload Status Notification */}
      {isUploading && (
        <div className="fixed top-0 left-0 w-full bg-yellow-500 text-white text-center py-2 z-50">
          Uploading sponge products...
        </div>
      )}
      
      {uploadStatus && (
        <div 
          className={`
            fixed 
            top-0 
            left-0 
            w-full 
            text-center 
            py-2 
            z-50 
            ${uploadStatus.success ? 'bg-green-500' : 'bg-red-500'} 
            text-white
          `}
        >
          {uploadStatus.message}
        </div>
      )}

      <div className="min-h-screen p-8 max-sm:p-1 lg:mt-[70px] mt-[130px]">
      {hasIncompatibleItems && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">
            Your cart contains items from a different box type. Please complete your current order 
            or clear the cart before selecting individual sponge products.
          </span>
          <button
            onClick={() => setHasIncompatibleItems(false)}
            className="absolute top-0 right-0 px-2 py-1"
          >
            ×
          </button>
        </div>
      )}
        <div className="flex justify-between items-center max-sm:flex-col max-sm:items-start mb-6">
          <h3 className="text-2xl font-semibold">Oil Products</h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6">
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              updateCartCount={updateCartCount}
              forceUpdateKey={forceUpdateKey} // Pass updateCartCount to ProductCard
            />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OilProduct;